exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".SMS-header[data-v-7e51063d]{display:flex;align-items:center;justify-content:space-between;height:36px;background-color:#eee;font-size:16px;padding:0 30px;margin:20px 0}.SMS-main[data-v-7e51063d]{box-sizing:border-box;width:640px;padding:0 30px}.card-wrap[data-v-7e51063d]{box-sizing:border-box;width:100%;height:200px;overflow:auto;padding:10px;margin:8px 0 4px;border:1px solid #c0ccda;border-radius:4px;font-size:14px;line-height:1.5}.card-footer[data-v-7e51063d]{text-align:right;font-size:14px;line-height:1.5}.dialog-item[data-v-7e51063d]{display:inline-block;margin:0 4px 4px;padding:4px;border:1px solid #c0ccda;border-radius:4px;font-size:14px;line-height:1.5}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-7e51063d&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/yunying/SMSManage/Detail/index.vue
// module id = 594
// module chunks = 0